function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

export var initialState = {
  items: []
};

var getChildren = function getChildren(item, items) {
  if (items === void 0) {
    items = [];
  }

  var children = [];

  var get = function get(currentItem, currentItems) {
    var _currentItem$children;

    if (currentItems === void 0) {
      currentItems = [];
    }

    if (!((_currentItem$children = currentItem.childrenValue) != null && _currentItem$children.length) || !(currentItem != null && currentItem.isOpen)) {
      return;
    }

    currentItem.childrenValue.forEach(itemValue => {
      var child = items.find(currentChild => currentChild.value === itemValue);

      if (child) {
        children.push(child);
        get(child, currentItems);
      }
    });
  };

  get(item, items);
  return [...children, item].map(currentItem => currentItem.value);
};

var getParents = function getParents(item, items) {
  if (items === void 0) {
    items = [];
  }

  var parents = [];

  var get = function get(currentItem, currentItems) {
    if (currentItems === void 0) {
      currentItems = [];
    }

    if (!currentItem.parentValue) {
      return;
    }

    var currentParentItem = currentItems.find(child => child.value === currentItem.parentValue);

    if (currentParentItem) {
      parents.push(currentParentItem);
      get(currentParentItem, currentItems);
    }
  };

  get(item, items);
  return parents.map(currentItem => currentItem.value);
};

export var accordionReducer = (state, _ref) => {
  var {
    type,
    payload = {}
  } = _ref;
  var {
    items = []
  } = state;

  switch (type) {
    case 'ADD_ITEM':
      {
        return {
          items: [...items, payload]
        };
      }

    case 'TOGGLE_ITEM':
      {
        var currentItem = items.find(item => item.value === payload.value);
        var children = getChildren(currentItem || {}, items);
        var itemsToToggle = [currentItem == null ? void 0 : currentItem.value, ...children];
        return {
          items: items.map(item => {
            return _extends({}, item, {
              isOpen: currentItem != null && currentItem.isOpen && itemsToToggle.indexOf(item.value) > -1 ? false : itemsToToggle.indexOf(item.value) > -1 ? !item.isOpen : item.isOpen
            });
          })
        };
      }

    case 'TOGGLE_SINGLE_ITEM':
      {
        return {
          items: items.map(item => {
            return _extends({}, item, {
              isOpen: payload.collapsible && payload.value === item.value ? !item.isOpen : payload.value === item.value
            });
          })
        };
      }

    case 'OPEN_SELECTED':
      {
        var _currentItem = items.find(item => item.value === payload.value);

        var parents = getParents(_currentItem || {}, items);
        var itemsToOpen = [_currentItem == null ? void 0 : _currentItem.value, ...parents];
        return {
          items: items.map(item => {
            return _extends({}, item, {
              isOpen: itemsToOpen.indexOf(item.value) > -1 ? true : item.isOpen
            });
          })
        };
      }

    case 'ADD_CHILDREN':
      {
        return {
          items: items.map(item => _extends({}, item, {
            childrenValue: item.value === payload.value ? [...item.childrenValue, payload.childValue] : [...item.childrenValue]
          }))
        };
      }

    default:
      return state;
  }
};
//# sourceMappingURL=accordionReducer.js.map